module.exports = __webpack_public_path__ + "static/media/privacy.704491a0.svg";